<template>
  <div class="page">
    <nav-bar/>
    <search-bar/>

    <div class style="width: 100vw;">
      <div class="page-content">


        <div class="p10">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/me/myIncome' }">我的收益</el-breadcrumb-item>
            <el-breadcrumb-item>提现</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div style="width: 646px;margin: 0 auto;padding: 50px 0">
          <div class="fr ac">
            <div>提现金额：</div>
            <el-input style="width: 300px" v-model="submit_form.withdraw_price" placeholder="请输入提现金额"></el-input>

          </div>

          <div class="grey mt10 fz14" style="margin-left: 80px">可提现金额：￥{{can_withdraw_price}}</div>

          <div style="margin-top: 70px">提现到</div>
          <el-divider></el-divider>
          <!--        银行卡列表-->

          <div class="bank-list" style="width: 100%">

            <el-radio-group v-model="submit_form.bank_id" style="width: 100%">


              <div class="item fr jsb ac p20" style="width: 100%;border-bottom: 1px solid #f5f5f5"
                   v-for="(item,index) in bank_list" :key="index">
                <div class="fz16">
                  <div>
                    {{item.bank_name}}
                  </div>
                  <div class="grey mt10">
                    {{item.bank_no}}
                  </div>
                </div>
                <div>
                  <el-radio :label="item.bank_id">

                    &nbsp;
                  </el-radio>
                </div>
              </div>
            </el-radio-group>


          </div>


        </div>



        <div class="fr jc ac pb50">
          <el-button type="primary" style="width: 315px" @click="applyWithdraw">提交</el-button>

        </div>
      </div>
    </div>

    <footer-bar/>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import SearchBar from "@/components/SearchBar";
  import FooterBar from "@/components/FooterBar";

  export default {
    props: {},
    data() {
      return {
        //能提现的金额
        can_withdraw_price:"",
        submit_form: {
          withdraw_price: "",
          bank_id: ""
        },
        bank_list: []

      };
    },
    computed: {},
    created() {
    },
    mounted() {
      let param=this.$route.query;
      this.can_withdraw_price=param.can_withdraw_price;
      this.getMemberBankList();
    },
    methods: {

      //申请提现
      applyWithdraw() {
        let param = Object.assign({}, this.submit_form);
        if (!param.withdraw_price) {
          this.$message("请输入提现金额")
          return;
        }
        if (!param.bank_id) {
          this.$message("请选择提现银行卡")
          return;
        }

        this.post("memberInterfaces/v1.0/insertMemberWithdraw", param).then(res => {
          this.$message('申请成功');
          setTimeout(() => {
            this.back();
          }, 1000)
        })
      },

      //获取用户银行卡列表
      getMemberBankList() {
        this.post("bankInterfaces/v1.0/getMemberBanks").then(res => {
          this.bank_list = res.data;
        })
      }
    },
    components: {
      "nav-bar": NavBar,
      "search-bar": SearchBar,
      "footer-bar": FooterBar
    }
  };
</script>

<style scoped lang="scss">
  .page-content {
    width: 1200px;
    margin: 20px auto;
    background-color: #ffffff;
  }

  .active {
    font-size: 20px;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/page/me/myIncome/withdraw.vue